module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_1_m.3c9adbfb0fe8ccc334dd06e601584ff2.png";